export const TWEETLISTPAGE_SET_SCPOS = 'TweetListPage_setScrollPos'
export const TWEETLISTPAGE_CHANGE_TYPE = 'TweetListPage_changeType'
export const STOCKLISTPAGE_SET_SCPOS = 'StockListPage_setScrollPos'
export const FLASH_SET_MSG = 'Flash_setMsg'
export const FLASH_CLEAR_MSG = 'Flash_clearMsg'



// WEBPACK FOOTER //
// ./src/store/action-types.js